import React from 'react'
import { cn } from './cn'

/**
 * 狀態圖示的語氣（design-guideline §7.3.1）：圖形說發生什麼事，顏色說使用者能不能繼續。
 * - `ok`：事情已經成立（已安裝、已完成）。
 * - `ink`：正常的結束或說明，沒有被擋住。
 * - `warn`：暫時不能做，但不用做任何事。
 * - `danger`：現在做不了，要換一條路（停用、沒有權限、無法確認）。
 * 品牌紅不用在這裡。
 */
export type StatusMarkTone = 'ok' | 'ink' | 'warn' | 'danger'

export interface StatusMarkProps {
  tone: StatusMarkTone
  /** 一個符號（勾、鎖、問號…），不疊兩個。 */
  children: React.ReactNode
  className?: string
}

const TONE: Record<StatusMarkTone, string> = {
  ok: 'text-ok-deep shadow-[inset_0_0_0_var(--border-emphasis)_var(--ok)]',
  ink: 'text-foreground shadow-[inset_0_0_0_var(--border-emphasis)_var(--border)]',
  warn: 'text-warn shadow-[inset_0_0_0_var(--border-emphasis)_var(--warn)]',
  danger: 'text-danger shadow-[inset_0_0_0_var(--border-emphasis)_var(--danger)]',
}

/**
 * 整頁結果、空狀態、無法繼續等畫面上方的圓框狀態圖示（設計側
 * `desktop-sleek-onboarding.html` 的 `.done-ok`）：44 的圓、細圈與符號同色系。
 * 純裝飾，意思由旁邊的標題說。
 */
export function StatusMark({ tone, children, className }: StatusMarkProps) {
  return (
    <span
      aria-hidden="true"
      data-status-mark={tone}
      className={cn(
        'grid size-11 flex-none place-items-center rounded-full [&_svg]:size-5.5',
        TONE[tone],
        className
      )}
    >
      {children}
    </span>
  )
}
